import type { ObjectMetadata } from '@olytic/foundation';

import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asCheck, asDateTime, createdByField, field, lastModifiedByField, lookup, type Row, text } from './kit';

const def = OBJECT_DEFS['research-findings'];

/** A stat or quote taken from a research source (0095). Rationale: research-findings.md. */
export const researchFindings: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Research Finding',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('statement', 'Statement', { wide: true, help: 'The finding in our words.' }),
    field('exact_quote', 'Exact Quote', { wide: true, help: "The source's own words." }),
    field('source_name', 'Source', { link: lookup('research-sources', 'source_id') }),
    field('page_number', 'Page Number'),
    field('quote_verified', 'Quote Verified', { format: asCheck, help: "Ticked once the exact quote was found in the source's text." }),
    field('figure_name', 'Figure', { link: lookup('research-figures', 'figure_id') }),
    field('tags', 'Tags'),
    field('created_at', 'Created', { format: asDateTime }),
    field('updated_at', 'Last Modified', { format: asDateTime }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['statement', 'exact_quote', 'source_name', 'page_number', 'quote_verified', 'figure_name', 'tags'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_at', 'created_by_name', 'updated_at', 'last_modified_by_name'] },
  ],
  related: [],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'source_name', 'tags'],
};
